module.exports = __webpack_public_path__ + "img/5.b647b1e8.webp";